import { h, ComponentChildren } from "preact";

import CSSProperties from "../../../foundation/model/CSSProperties";
import classname from "../../../foundation/utils/classname";

import styles from "./ItemStack.module.css";

interface Props {
    children: ComponentChildren;
    opacity?: number;
    numberOfItems?: number;
}

const MAX_NUMBER_OF_ITEMS_TO_RENDER = 3;
const DEFAULT_OPACITY = 0.5;

function ItemStack({
    children,
    opacity = DEFAULT_OPACITY,
    numberOfItems = 1
}: Props) {
    const numberOfItemsToRender = Math.max(Math.min(numberOfItems, MAX_NUMBER_OF_ITEMS_TO_RENDER), 1);
    const itemsToRender = new Array(numberOfItemsToRender).fill(children);
    const style = {
        "--item-stack-opacity": opacity,
        "--item-stack-number-of-items-to-render": numberOfItemsToRender
    } as CSSProperties;

    function renderItems() {
        return (
            <div class={styles.items}>
                {itemsToRender.map((itemToRender, index) => (
                    <div
                        key={index}
                        class={classname(styles.item, {
                            [styles.level0]: index === 0,
                            [styles.level1]: index === 1,
                            [styles.level2]: index === 2
                        })}>
                        {itemToRender}
                    </div>
                ))}
            </div>
        );
    }

    function renderCount() {
        return (
            <div class={classname("caption-1 medium", styles.count)}>
                {numberOfItems}
            </div>
        );
    }

    return (
        <div class={classname(styles.itemStack)} style={style}>
            {renderItems()}
            {numberOfItems > 1 && renderCount()}
        </div>
    );
}

export default ItemStack;
